<template>
    <a-card class="experienceCourse">
        <a-form-model layout="inline">
            <a-form-model-item label="系列名称">
                <a-input placeholder="请输入" allow-clear :maxLength="20" v-model="searchForm.name" style="width:220px;"/>
            </a-form-model-item>
            <a-form-model-item label="系列状态">
                <a-select class="serach-item" allowClear v-model="searchForm.enabled" @keyup.enter="getList(1)"
                          placeholder="请选择">
                    <a-select-option value="true">开启</a-select-option>
                    <a-select-option value="false">关闭</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="getList(1)">查询</a-button>
                <a-button style="margin: 0 35px 0 15px;" @click="resetSearch()">重置</a-button>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="addSeries()" v-permission="`Operate.ExperienceCourse.AddSeries`">添加系列
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="table">
            <a-table style="min-width: 800px;"
                     :columns="columns"
                     row-key="id"
                     @expand="getCourseTable"
                     @expandedRowsChange="expandedRowsChange"
                     :expandedRowKeys="tableExpandedRowKeys"
                     :pagination="tableRelevant.tablePagination"
                     :loading="tableRelevant.tableLoading"
                     :locale="tableRelevant.locale"
                     :dataSource="tableRelevant.tableDataSource">
                <div slot="status" slot-scope="text, record" class="_flex"
                     v-auth="`Operate.ExperienceCourse.SeriesStatus`">
                    <a-switch checked-children="开启" un-checked-children="关闭" :checked="text.enabled"
                              @click="statusChange(text)"/>
                </div>
                <div slot="action" slot-scope="text, record" class="action">
                    <a @click="editSeries(text)" v-permission="`Operate.ExperienceCourse.EditSeries`">编辑</a>
                    <a @click="addCourse(text)" v-permission="`Operate.ExperienceCourse.AddCourse`">添加</a>
                    <a-dropdown>
                        <a class="ant-dropdown-link">更多
                            <a-icon type="down"/>
                        </a>
                        <a-menu slot="overlay">
                            <a-menu-item v-permission="`Operate.ExperienceCourse.SeriesCode`">
                                <a @click="seriesCode(text)">系列码</a>
                            </a-menu-item>
                            <a-menu-item v-permission="`/operate/ChannelDispose/FreeEvaluationChannel`">
                                <a @click="channel(text)"
                                   href="javascript:;">渠道链接</a>
                            </a-menu-item>
                            <a-menu-item v-permission="`Operate.ExperienceCourse.DeleteSeries`">
                                <a @click="deleteSeries(text)">删除</a>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </div>
                <a-table
                        slot="expandedRowRender"
                        slot-scope="parentText,parentRecord"
                        rowKey="id"
                        :loading="innerLoading"
                        :columns="innerColumns"
                        :data-source="innerData"
                        :pagination="false">
                    <div slot="name" slot-scope="text, record" class="_flex">
                        <div>
                            <img src=""/>
                            <span>{{text.name}}</span>
                        </div>
                    </div>
                    <div slot="age" slot-scope="text, record" class="_flex">
                        {{text.minAge}} - {{text.maxAge}}
                    </div>
                    <div slot="courseType" slot-scope="text, record" class="_flex">
                        {{text.courseType == 1 ? '测评课程' : text.courseType == 2 ? '训练课程' : '其他课程'}}
                    </div>
                    <div slot="price" slot-scope="text, record" class="_flex">
                        ￥{{text.price}}
                    </div>
                    <div slot="status" slot-scope="text, record" class="_flex"
                         v-auth="`Operate.ExperienceCourse.CourseStatus`">
                        <a-switch checked-children="开启" un-checked-children="关闭" :checked="text.enabled"
                                  @click="courseStatusChange(text)"/>
                    </div>
                    <div slot="operation" class="table-operation action" slot-scope="text,record">
                        <a @click="courseChildSet(text,1)"
                           v-permission="`Operate.ExperienceCourse.CourseChildSet`">课时配置</a>
                        <a @click="lookCourse(text)" v-permission="`/operate/ExperienceCourse/LookCourseDetail`">查看</a>
                        <a-popconfirm title="确定要删除该课程吗？" v-permission="`Operate.ExperienceCourse.DeleteCourse`"
                                      @confirm="deleteCourse(record)">
                            <a class="red">
                                <a-icon type="delete"/>
                                删除
                            </a>
                        </a-popconfirm>
                    </div>
                </a-table>
            </a-table>
        </div>
        <!-- 添加编辑系列 -->
        <a-modal width="800px"
                 :title="seriesForm.title"
                 :visible="seriesForm.visible"
                 destroyOnClose
                 :maskClosable="true"
                 :confirm-loading="seriesForm.loading"
                 @ok="seriesFormOk"
                 @cancel="seriesFormCancel">
            <a-form-model ref="seriesForm"
                          :label-col="{span:6}"
                          :wrapper-col="{span:14}"
                          :model="seriesForm.data"
                          :rules="seriesForm.rules">
                <a-form-model-item ref="name" label="系列名称" prop="name">
                    <a-input v-model="seriesForm.data.name" :maxLength="20"/>
                </a-form-model-item>
                <a-form-model-item ref="description" label="系列描述">
                    <a-input v-model="seriesForm.data.description" type="textarea" :maxLength="50"/>
                </a-form-model-item>
                <a-form-model-item ref="description" label="链接配置">
                    <a-switch checked-children="开" un-checked-children="关"
                              v-model="seriesForm.data.isPromotionUriEable"/>
                </a-form-model-item>
                <a-form-model-item label="上传详情图" prop="introduceUri" v-if="seriesForm.data.isPromotionUriEable">
                    <a-upload name="imgFile"
                              list-type="picture-card"
                              :show-upload-list="false"
                              :action="action"
                              :before-upload="imgBeforeUpload"
                              @change="imgIntroduceUriChange">
                        <img style="width: 100%;" v-if="seriesForm.data.introduceUri"
                             :src="seriesForm.data.introduceUri | filterUrl" alt="avatar"/>
                        <div v-else>
                            <a-icon :type="seriesForm.imgIntroduceUriLoading ? 'loading' : 'plus'"/>
                        </div>
                    </a-upload>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <!-- 系列码 -->
        <a-modal :visible="seriesCodeShow" destroyOnClose :closable="false" :footer="null">
            <div class="seriesCodeBox">
                <div class="tit">
                    <a>
                        <a-icon type="info-circle" style="font-size:20px;"/>
                    </a>
                    <span style="margin-left:15px;">系列码生成结果</span>
                </div>
                <div class="tit" style="padding-left:36px;margin-top:20px;">
                    <span style="font-size:20px;">{{code}}</span>
                    <a style="margin-left:15px;font-size: 14px;" @click="copy(code)">复制</a>
                </div>
                <a-button type="primary" @click="seriesCodeShow = false" class="btn">知道了</a-button>
            </div>
        </a-modal>
        <!-- 添加课程 -->
        <a-modal
                title="添加课程"
                :visible="courseForm.visible"
                destroyOnClose
                width="900px"
                @ok="courseFormOk"
                @cancel="courseFormCancel">
            <a-form-model layout="inline">
                <a-form-model-item label="课程查询">
                    <a-input placeholder="请输入课程名称" allow-clear :maxLength="20" v-model="courseForm.name"
                             style="width:220px;"/>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="primary" @click="GetCourseResoursePageList(1)">查询</a-button>
                </a-form-model-item>
            </a-form-model>
            <div class="table" style="margin-top:15px;position: relative;">
                <a-table style="min-width: 800px;max-height: 400px;overflow-y: auto;"
                         :columns="courseColumns"
                         row-key="id"
                         :row-selection="rowSelection"
                         :pagination="courseForm.tableRelevant.tablePagination"
                         :loading="courseForm.tableRelevant.tableLoading"
                         :locale="courseForm.tableRelevant.locale"
                         :dataSource="courseForm.tableRelevant.tableDataSource">
                    <div slot="period" slot-scope="text, record" class="_flex">
                        {{text.period}}
                    </div>
                    <div slot="age" slot-scope="text, record" class="_flex">
                        {{text.minAge}} - {{text.maxAge}}
                    </div>
                    <div slot="courseType" slot-scope="text, record" class="_flex">
                        {{text.courseType == 1 ? '测评课程' : text.courseType == 2 ? '训练课程' : '其他课程'}}
                    </div>
                    <div slot="price" slot-scope="text, record" class="_flex">
                        ￥{{text.price}}
                    </div>
                    <div slot="action" slot-scope="text, record">
                        <a @click="edit(text)">编辑</a>
                        <a @click="detail(text)" style="margin-left:15px;">项目详情</a>
                        <a-popconfirm title="确定删除？" @confirm="deleteProject(record)"
                                      style="margin-left:15px;color:red;">
                            <a class="red">
                                <a-icon type="delete"/>
                                删除
                            </a>
                        </a-popconfirm>
                    </div>
                </a-table>
                <p style="position: absolute;bottom: -75px;">已选课程 {{conselectedRows.length}} 个</p>
            </div>
        </a-modal>
        <!-- 课时配置 -->
        <a-modal :visible="courseChildSetShow" title="课时配置" destroyOnClose @cancel="courseChildSetShow = false"
                 :footer="null" width="900px">
            <a-table style="min-width: 600px;max-height: 400px;overflow-y: auto;"
                     :columns="courseChildColumns"
                     :pagination="courseChildData.tablePagination"
                     :loading="courseChildData.tableLoading"
                     :locale="courseChildData.locale"
                     :dataSource="courseChildData.tableDataSource">
                <div slot="status" slot-scope="text, record" class="_flex"
                     v-auth="`Operate.ExperienceCourse.CourseChildStatus`">
                    <a-switch checked-children="开启" un-checked-children="关闭" :checked="text.ruleType == 0"
                              @click="ruleTypeChange(text)"/>
                </div>
            </a-table>
        </a-modal>
    </a-card>
</template>

<script>
    import Apis from "@/requests/apis";
    import {tableRelevant} from "@/pages/projectImpl/js/utils";

    const columns = [
        {title: '系列名称', key: "1", dataIndex: 'name'},
        {title: '系列描述', key: "2", dataIndex: 'description'},
        {title: '领取量', key: "3", dataIndex: 'receiveCount'},
        {title: '状态', key: "6", scopedSlots: {customRender: 'status'}},
        {title: '操作', key: "7", scopedSlots: {customRender: 'action'}}
    ]
    const innerColumns = [
        {title: "课程名称", scopedSlots: {customRender: "name"}},
        {title: "适用年龄", scopedSlots: {customRender: "age"}},
        {title: "类型", scopedSlots: {customRender: "courseType"}},
        {title: "课时数", dataIndex: "childCourseCount"},
        {title: "体验课时数", dataIndex: "expChildCourseCount"},
        {title: "领取量", dataIndex: "receiveCount"},
        {title: "价格", scopedSlots: {customRender: "price"}},
        {title: "状态", scopedSlots: {customRender: "status"}},
        {title: "操作", scopedSlots: {customRender: "operation"}}
    ];

    const courseColumns = [
        {title: "课程名称", dataIndex: "name"},
        {title: "适用学段", scopedSlots: {customRender: "period"}},
        {title: "课时数", dataIndex: "childCourseCount"},
        {title: "类型", scopedSlots: {customRender: "courseType"}},
        {title: "年龄段", scopedSlots: {customRender: "age"}},
        {title: "价格", scopedSlots: {customRender: "price"}},
    ]

    const courseChildColumns = [
        {title: "课时名称", dataIndex: "childCourseName", key: '1'},
        {title: "体验状态", scopedSlots: {customRender: "status"}, key: '2'},
    ]
    export default {
        name: "experienceCourse",
        data() {
            return {
                action: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + "?filePath=content/course",
                searchForm: {
                    name: '',
                    enabled: undefined
                },
                statusArr: ['开启', '关闭'],
                columns,
                tableRelevant: tableRelevant.call(this, this.getList),
                innerColumns,
                innerData: [],
                innerLoading: false,
                tableExpandedRowKeys: [], //表格展开的行
                seriesForm: {
                    visible: false,
                    loading: false,
                    imgBannerUriLoading: false,
                    imgIntroduceUriLoading: false,
                    title: '添加系列',
                    data: {
                        name: '',
                        description: '',
                        introduceUri: '',
                        isPromotionUriEable: false
                    },
                    rules: {
                        name: [{required: true, message: "请填写系列名称", trigger: "blur"}],
                        introduceUri: [{required: true, message: "请上传详情图", trigger: "change"}]
                    }
                },
                currentId: '',
                // 系列码
                seriesCodeShow: false,
                code: '259962',
                courseColumns,
                courseForm: {
                    visible: false,
                    name: '',
                    GroupId: '',
                    tableRelevant: tableRelevant.call(this, this.GetCourseResoursePageList),
                },
                conselectedRows: [],
                // 课时配置
                courseChildSetShow: false,
                courseChildColumns,
                courseChildData: tableRelevant.call(this, this.getCourseChildSetList),
                courseChildSetId: '',
                courseId: '',
                recordId: ''
            }
        },
        computed: {
            rowSelection() {
                return {
                    selectedRowKeys: this.conselectedRows,
                    onChange: (selectedRowKeys, selectedRows) => {
                        this.conselectedRows = selectedRowKeys;
                        console.log(this.conselectedRows)
                    },
                };
            }
        },
        mounted() {
            this.getList(1)
        },
        methods: {
            // 展开行
            expandedRowsChange(expandedRowKeys) {
                if (expandedRowKeys.length > 1) {
                    this.tableExpandedRowKeys = [expandedRowKeys.pop()];
                } else {
                    this.tableExpandedRowKeys = expandedRowKeys;
                }
            },
            // 系列
            getList(pageIndex) {
                let params = {
                    ...this.searchForm,
                    promotionGroupType: 2,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                }
                this.tableRelevant.tableLoading = true
                this.$http.operate.GetGroupPageList(params)
                    .then(res => {
                      this.tableRelevant.tableLoading = false
                            this.tableRelevant.tableDataSource = res.data.items
                            this.tableRelevant.tablePagination.total = res.data.totalCount;
                            this.tableRelevant.tablePagination.current = res.data.pageIndex;
                       
                    })
                    .catch(err => {
                        this.tableRelevant.tableLoading = false
                    })
            },
            addSeries() {
                this.seriesForm.visible = true
                this.seriesForm.title = '添加系列'
            },
            editSeries(text) {
                this.seriesForm.visible = true
                this.seriesForm.title = '编辑系列'
                for (let key in this.seriesForm.data) {
                    this.seriesForm.data[key] = text[key]
                }
                this.currentId = text.id
            },
            imgBeforeUpload(file) {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                    this.$message.error('请上传jpg或者png图片!')
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('图片大小不能超过2M!')
                }
                return isJpgOrPng && isLt2M
            },

            imgIntroduceUriChange(info) {
                if (info.file.status === 'uploading') {
                    this.seriesForm.imgIntroduceUriLoading = true;
                    return;
                }
                if (info.file.status === 'done') {
                    this.seriesForm.imgIntroduceUriLoading = false;
                    if (info.file.response.status) {
                        this.seriesForm.data.introduceUri = info.file.response.data;
                    } else {
                        this.$message.error(info.file.response.message);
                    }
                }
            },
            deleteSeries(text) {
                this.$confirm({
                    title: '确定删除该系列',
                    centered: true,
                    okType: 'danger',
                    onOk: () => {
                        this.tableRelevant.tableLoading = true
                        let formData = new FormData();
                        formData.append('id', text.id);
                        this.$http.operate.DeleteGroup(formData)
                            .then(res => {
                                this.tableRelevant.tableLoading = false
                                this.$message.success('删除成功')
                                this.getList(1)
                            })
                            .catch(err => {
                                this.tableRelevant.tableLoading = false
                            })
                    }
                });
            },
            statusChange(text) {
                this.tableRelevant.tableLoading = true
                let formData = new FormData();
                formData.append('id', text.id);
                this.$http.operate.UpdateStatus(formData)
                    .then(res => {
                        this.$message.destroy();
                        this.tableRelevant.tableLoading = false
                        this.$message.success('操作成功')
                        text.enabled = !text.enabled
                    })
                    .catch(err => {
                        this.tableRelevant.tableLoading = false
                    })
            },
            seriesFormOk() {
                this.$refs.seriesForm.validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.seriesForm.data,
                            promotionGroupType: 2,
                        }
                        if (this.seriesForm.title == '编辑系列') {
                            params.id = this.currentId
                        }
                        this.$http.operate.EditCourseConfigGroup(params)
                            .then(() => {
                                this.$message.success('添加成功')
                                this.getList(1)
                                this.seriesForm.visible = false
                                this.seriesForm.data = {
                                    name: '',
                                    description: '',
                                    bannerUri: '',
                                    introduceUri: '',
                                    isPromotionUriEable: false
                                }
                            })
                            .catch(err => {

                            })
                    } else {
                    }
                });
            },
            seriesFormCancel() {
                this.seriesForm.visible = false
                this.$refs.seriesForm.resetFields();
                this.seriesForm.data = {
                    name: '',
                    description: '',
                    bannerUri: '',
                    introduceUri: '',
                    isPromotionUriEable: false
                }
            },
            // 系列码
            seriesCode(text) {
                this.seriesCodeShow = true
                this.code = text.code
            },
            channel(val) {
                this.$message.destroy();
                if (val.isPromotionUriEable) {
                    this.$router.push({
                        path: "/operate/ChannelDispose/FreeEvaluationChannel",
                        query: {
                            id: val.id,
                            name: val.name,
                            type: 1
                        }
                    });
                } else {
                    this.$message.error("请先开启该系列链接配置，再次尝试");
                }

            },
            // 复制
            copy(val) {
                this.$message.destroy();
                try {
                    if (window.clipboardData) {
                        window.clipboardData.setData('text', val);
                    } else {
                        (function (s) {
                            document.oncopy = function (e) {
                                e.clipboardData.setData('text', s);
                                e.preventDefault();
                                document.oncopy = null;
                            }
                        })(val);
                        document.execCommand('Copy');
                    }
                    this.$message.success("复制成功");
                } catch (e) {
                    this.$message.error("复制失败，请手动复制🐕！");
                }
            },

            // 课程
            getCourseTable(expanded, record) {
                if (expanded) {
                    this.GetGroupCourseDetailPageList(record.id)
                }
            },
            addCourse(text) {
                this.courseForm.visible = true
                this.courseForm.GroupId = text.id
                this.conselectedRows = []
                this.GetCourseResoursePageList(1)
            },
            // 获取添加课程的列表
            GetCourseResoursePageList(pageIndex) {
                let params = {
                    GroupId: this.courseForm.GroupId,
                    name: this.courseForm.name,
                    pageIndex: pageIndex || this.courseForm.tableRelevant.tablePagination.current,
                    pageSize: this.courseForm.tableRelevant.tablePagination.pageSize,
                }
                this.$http.operate.GetCourseResoursePageList(params)
                    .then(res => {
                        this.$message.destroy();
                        this.courseForm.tableRelevant.tableLoading = false
                        this.courseForm.tableRelevant.tableDataSource = res.data.data.items
                        this.courseForm.tableRelevant.tablePagination.total = res.data.data.totalCount;
                        this.courseForm.tableRelevant.tablePagination.current = res.data.data.pageIndex;
                    })
                    .catch(err => {
                        this.courseForm.tableRelevant.tableLoading = false
                    })
            },
            // 获取系列下课程
            GetGroupCourseDetailPageList(recordId) {
                this.recordId = recordId
                let params = {
                    GroupId: recordId || this.courseForm.GroupId
                }
                this.innerLoading = true
                this.$http.operate.GetGroupCourseDetailPageList(params)
                    .then(res => {
                        this.$message.destroy();
                        this.innerLoading = false
                        this.innerData = res.data.data.items
                    })
                    .catch(err => {
                        this.innerLoading = false
                    })
            },
            // 修改课程状态
            courseStatusChange(text) {
                this.innerLoading = true
                let formData = new FormData();
                formData.append('id', text.id)
                this.$http.operate.courseStatusChange(formData)
                    .then(res => {
                        this.$message.destroy();
                        this.innerLoading = false
                        this.$message.success(res.message)
                        text.enabled = !text.enabled
                    })
                    .catch(err => {
                        this.innerLoading = false
                    })
            },
            courseFormOk() {
                this.$message.destroy();
                if (!this.conselectedRows.length) {
                    this.$message.error('请选择课程')
                    return
                }
                let arr = this.conselectedRows
                let params = {
                    name: '',
                    courseIds: arr,
                    description: '',
                    businessScenarioType: 3,
                    groupId: this.courseForm.GroupId
                }
                this.$http.operate.GroupAddCourse(params)
                    .then(() => {
                        this.$message.success('添加成功')
                        this.courseForm.visible = false
                        this.GetGroupCourseDetailPageList(this.recordId)
                    })
                    .catch(err => {

                    })
            },
            courseFormCancel() {
                this.courseForm.visible = false
                this.courseForm.name = ''
                this.conselectedRows = []
            },
            ruleTypeChange(text) {
                let formData = new FormData();
                if (text.id) {
                    formData.append('id', text.id);
                }
                formData.append('CourseConfigId', text.courseConfigId);
                formData.append('ChildCourseId', text.childCourseId);
                formData.append('RuleType', text.ruleType == 0 ? 4 : 0);
                formData.append('RuleValue', text.ruleValue);
                this.$http.operate.UpdateRuleType(formData)
                    .then(res => {
                        this.$message.destroy();
                        this.$message.success('操作成功')
                        text.ruleType = text.ruleType == 0 ? 4 : 0
                    })
                    .catch(err => {
                    })
            },
            // 课时配置
            courseChildSet(text) {
                this.courseChildSetShow = true
                this.courseChildSetId = text.id
                this.courseId = text.courseId
                this.getCourseChildSetList(1)
            },
            // 查看课程详情
            lookCourse(val) {
                this.$store.commit("operate/setCourseInfo", val);
                this.$router.push({
                    path: "/operate/ExperienceCourse/LookCourseDetail"
                })
            },
            getCourseChildSetList(pageIndex) {
                let params = {
                    CourseConfigId: this.courseChildSetId,
                    courseId: this.courseId,
                    pageIndex: pageIndex || this.courseChildData.tablePagination.current,
                    pageSize: this.courseChildData.tablePagination.pageSize,
                }
                this.$http.operate.GetChildCourseConfigPageList(params)
                    .then(res => {
                        this.$message.destroy();
                        this.courseChildData.tableLoading = false
                        this.courseChildData.tableDataSource = res.data.items
                        this.courseChildData.tablePagination.total = res.data.totalCount;
                        this.courseChildData.tablePagination.current = res.data.pageIndex;
                    })
                    .catch(err => {
                        this.courseChildData.tableLoading = false
                    })
            },
            // 删除课程
            deleteCourse(text) {
                this.$message.destroy();
                let formData = new FormData();
                formData.append('id', text.id);
                this.$http.operate.DeleteCourse(formData)
                    .then(() => {
                        this.$message.success('删除成功')
                        this.GetGroupCourseDetailPageList(this.recordId)
                    })
                    .catch(err => {

                    })
            },
            resetSearch() {
                this.searchForm = {
                    name: '',
                    enabled: undefined
                }
                this.getList(1)
            },
        }
    }
</script>

<style scoped lang="less">
    /deep/ .ant-modal-confirm-content span {
        color: #f00;
    }

    .seriesCodeBox {
        padding-bottom: 30px;
        position: relative;
        .tit {
            display: flex;
            a {
                display: flex;
                align-items: center;
            }
            span {
                font-weight: 600;
            }
        }
        .btn {
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }

</style>
